<template>
  <v-container>
    <v-card class="rounded-lg" elevation="3" flat @click="goToResultDetail">
      <v-card-text>
        <v-row align="center">
          <v-col cols="8">
            {{ translations.label_analysis_folio }} {{ folioAnalysis.folio }} -
            {{ getTyoe(folioAnalysis.type) }}
            <v-spacer></v-spacer>
            <span>{{ translations.label_next_result_date }}:</span>
            <span v-if="folioAnalysis.nextResult.length > 0">
              {{ folioAnalysis.nextResult }}
            </span>
            <span v-else>
              {{ translations.label_not_available }}
            </span>
          </v-col>
          <v-col cols="4">
            <v-row class="mb-0" justify="end">
              <v-col cols="12" class="row pb-0 pt-4 justify-end mr-1">
                <div
                  v-if="
                    (folioAnalysis.type === 'INITIAL' ||
                      folioAnalysis.type === 'Initial') &&
                      folioAnalysis.status === 'VALUATED'
                  "
                >
                  <v-icon color="primary">mdi-check-all</v-icon>
                </div>
                <div
                  v-else-if="
                    (folioAnalysis.type === 'INITIAL' ||
                      folioAnalysis.type === 'Initial') &&
                      folioAnalysis.status === 'VALUATING'
                  "
                >
                  <v-icon color="accent">mdi-timer-sand</v-icon>
                </div>
                <div
                  v-else-if="
                    (folioAnalysis.type === 'INITIAL' ||
                      folioAnalysis.type === 'Initial') &&
                      folioAnalysis.status === 'MEASURED'
                  "
                >
                  <v-icon color="primary">mdi-check-all</v-icon>
                </div>
                <div
                  v-else-if="
                    (folioAnalysis.type === 'INITIAL' ||
                      folioAnalysis.type === 'Initial') &&
                      folioAnalysis.status === 'MEASURING'
                  "
                >
                  <v-icon color="accent">mdi-timer-sand</v-icon>
                </div>
                <div
                  v-else-if="
                    (folioAnalysis.type === 'INITIAL' ||
                      folioAnalysis.type === 'Initial') &&
                      folioAnalysis.status === 'RECEIVED'
                  "
                >
                  <v-icon color="primary">mdi-check-all</v-icon>
                </div>
                <div
                  v-else-if="
                    (folioAnalysis.type === 'MONITORING' ||
                      folioAnalysis.type === 'Monitoring') &&
                      folioAnalysis.status === 'MEASURED'
                  "
                >
                  <v-icon color="primary">mdi-check-all</v-icon>
                </div>
                <div
                  v-else-if="
                    (folioAnalysis.type === 'MONITORING' ||
                      folioAnalysis.type === 'Monitoring') &&
                      folioAnalysis.status === 'MEASURING'
                  "
                >
                  <v-icon color="accent">mdi-timer-sand</v-icon>
                </div>
                <div
                  v-else-if="
                    (folioAnalysis.type === 'MONITORING' ||
                      folioAnalysis.type === 'Monitoring') &&
                      folioAnalysis.status === 'RECEIVED'
                  "
                >
                  <v-icon color="primary">mdi-check-all</v-icon>
                </div>

                <span
                  v-if="
                    folioAnalysis.type === 'INITIAL' ||
                      folioAnalysis.type === 'Initial'
                  "
                  :class="
                    folioAnalysis.status === 'VALUATED' ||
                    folioAnalysis.status === 'RECEIVED' ||
                    folioAnalysis.status === 'MEASURED'
                      ? 'primary--text'
                      : 'accent--text'
                  "
                  >{{ getStatus(folioAnalysis.status) }}</span
                >
                <span
                  v-if="
                    folioAnalysis.type === 'MONITORING' ||
                      folioAnalysis.type === 'Monitoring'
                  "
                  :class="
                    folioAnalysis.status === 'MEASURED' ||
                    folioAnalysis.status === 'RECEIVED'
                      ? 'primary--text'
                      : 'accent--text'
                  "
                  >{{ getStatus(folioAnalysis.status) }}</span
                >
              </v-col>
            </v-row>
            <v-row class="mt-0" justify="end">
              <v-col class="pt-4 text-end">
                <span>{{ getFormattedSimple(folioAnalysis.date) }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  props: {
    folioAnalysis: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected"]),
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    getFormattedSimple(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    getStatus(value) {
      return this.translations.status_samples[value] || value;
    },
    getTyoe(value) {
      if (value === "INITIAL" || value === "Initial") {
        return this.translations.analysisTypes["INITIAL"];
      } else {
        return this.translations.analysisTypes["MONITORING"];
      }
    },
    goToResultDetail() {
      let flag = true;
      if (this.folioAnalysis.type == "MONITORING") {
        if (this.folioAnalysis.status === "MEASURING") {
          flag = false;
        }
      }
      if (flag) {
        this.$router.push(`/result-detail/${this.folioAnalysis.folio}`);
      } else {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "info",
          text: this.translations.label_analysis_in_progress,
          timeout: 4000,
        });
      }
    },
  },
};
</script>
